// The lifecycle of the client's own event, kept in step with canTransition in internal/events.
//
// The states a booking moves through describe negotiating with somebody else for space: enquiry,
// held, provisional, declined. An event the client is running has nobody to negotiate with, so it
// is planned, committed to, run, and finished instead. Putting a booking's vocabulary in front of
// somebody creating an internal event was the original mistake this split exists to undo.

export const EVENT_CREATE_STATUSES = ["draft", "planning", "confirmed"];

export const EVENT_STATUSES = [
  "draft",
  "planning",
  "confirmed",
  "in_progress",
  "completed",
  "cancelled",
];

const transitions: Record<string, string[]> = {
  draft: ["planning", "confirmed", "cancelled"],
  planning: ["confirmed", "cancelled"],
  confirmed: ["in_progress", "completed", "cancelled"],
  in_progress: ["completed", "cancelled"],
};

// A completed or cancelled event never moves again. What happened is not a draft, and the server
// refuses the same moves, so offering them here would only produce a rejection.
export function eventTransitions(status: string): string[] {
  return transitions[status] ?? [];
}
